export { default as ModalTos } from './ModalTos'
export { default as ModalMinuta } from './ModalMinuta'
export { default as ModalDocusign } from './ModalDocusign'
